type HighlightCalendarTimeRangeParams = {
  /** The time range the calendar shows now. Its width is kept. */
  currentTimeStart: number
  currentTimeEnd: number
  /** The highlighted instance. The end is missing when the highlight starts from a place that only knows the start. */
  eventStart: number
  eventEnd?: number
}

const longEventLeadFraction = 0.05

/**
 * The time range to move a calendar to so that the highlighted instance is in view, with the width of the current range.
 *
 * An instance that fits in the range is centered by its middle, so that the whole of it shows. A longer one starts a
 * little after the left edge, so that its start and the days after it show. Without the end of the instance the range
 * is centered on its start.
 */
export const getHighlightCalendarTimeRange = ({ currentTimeStart, currentTimeEnd, eventStart, eventEnd }: HighlightCalendarTimeRangeParams) => {
  const width = Math.max(currentTimeEnd - currentTimeStart, 0)
  const eventDuration = eventEnd !== undefined && eventEnd > eventStart ? eventEnd - eventStart : 0

  if (eventDuration > width) {
    const timeStart = Math.round(eventStart - width * longEventLeadFraction)

    return { timeStart, timeEnd: timeStart + width }
  }

  const center = Math.round(eventStart + eventDuration / 2)
  const timeStart = center - Math.round(width / 2)

  return { timeStart, timeEnd: timeStart + width }
}
